import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { HOMEPAGE_GA_TAGS, HOMEPAGE_SECTIONS } from 'Utilities/analytics/analyticsHomePage';
import { useFeatureFlags } from 'Utilities/hooks';

import { FeesTable } from 'Components/transactionFees/FeesTable/FeesTable';
import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';
import { ExpandableSection } from '../../../fastlane/expandableSection/ExpandableSection';

import LocalTexts from './HomepageFAQTexts.json';

import styles from './HomepageFAQ.scss';

type Props = {
  readonly className?: string;
}

const LocalT = new MDText(LocalTexts);
const t = (key: string) => LocalT.translate(key) as string;

const TEXT = {
  imgAlt: t('imgAlt'),
  title: t('title'),
};

const faqContent = Object.values(LocalTexts.content);
const faqContentWithFees = Object.values(LocalTexts.contentWithFees);
const contentWithFeesNew = Object.values(LocalTexts.contentWithFeesNew);

export const HomepageFAQ = ({ className }: Props) => {
  const onRefTrigger = () => HOMEPAGE_GA_TAGS.SECTION_LOADED(HOMEPAGE_SECTIONS.FAQ);
  const { setRef } = usePageRefEvents({ onRefTrigger });
  const { showServiceFee, useServiceFeesUpdate27 } = useFeatureFlags();
  const faqContentFees = useServiceFeesUpdate27 ? contentWithFeesNew : faqContentWithFees;
  const faqs = showServiceFee ? faqContentFees : faqContent;

  const [portalTarget, setPortalTarget] = useState<Element | null>(null);

  useEffect(() => {
    const target = document.getElementById('fees-table-portal');
    if (target) {
      setPortalTarget(target);
    }
  }, []);

  return (
    <RoundedSection withTopLedge className={cx(styles.component, className)}>
      <Content ref={(ref) => setRef(ref)} className={styles.faqContent} data-testid='homepageFAQ'>
        <ExpandableSection content={faqs} title={TEXT.title} />
        {showServiceFee && portalTarget && createPortal(
          <FeesTable />,
          portalTarget,
        )}
      </Content>
    </RoundedSection>
  );
};
